export default __webpack_public_path__ + "static/media/illustration_404.77160f9d.svg";